import { createPopper } from "@popperjs/core";

export const globalAbbreviation = () => {
    const abbreviations = document.querySelectorAll("abbr");

    abbreviations.forEach(abbreviation => {
        abbreviation.classList.add("global-abbreviation")

        const arrow = document.createElement("span");
        arrow.classList.add("global-abbreviation-arrow")
        arrow.setAttribute("data-popper-arrow", "")

        const tooltipElement = document.createElement("div");
        tooltipElement.classList.add("global-abbreviation-tooltip");
        tooltipElement.appendChild(arrow)

        const content = document.createElement("div");
        content.classList.add("global-abbreviation-content");

        const dataHeadline = abbreviation.getAttribute("data-headline")
        if (dataHeadline) {
            const popperHeadline = document.createElement("p");
            popperHeadline.classList.add("global-abbreviation__headline")
            popperHeadline.textContent = dataHeadline
            content.appendChild(popperHeadline)
        }

        const popperExplanation = document.createElement("span");
        popperExplanation.textContent = abbreviation.getAttribute("title");
        popperExplanation.classList.add("global-abbreviation__explanation")
        content.appendChild(popperExplanation)

        tooltipElement.appendChild(content)

        document.body.appendChild(tooltipElement)

        const options = {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 20],
                    },
                },
            ],
        }

        const popperInstance = createPopper(abbreviation, tooltipElement, options)

        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];

        function show() {
            tooltipElement.setAttribute('data-show', '');
            const title = abbreviation.getAttribute('title')
            abbreviation.setAttribute("title", "")
            abbreviation.setAttribute("data-title", title)
            // We need to tell Popper to update the tooltip position
            // after we show the tooltip, otherwise it will be incorrect
            popperInstance.update();
        }

        function hide() {
            tooltipElement.removeAttribute('data-show');
            const title = abbreviation.getAttribute('data-title')
            abbreviation.setAttribute("data-title", "")
            abbreviation.setAttribute("title", title)
        }

        showEvents.forEach((event) => {
            abbreviation.addEventListener(event, show);
        });

        hideEvents.forEach((event) => {
            abbreviation.addEventListener(event, hide);
        });
    })
}
